import Header from "./sub-components/Header";
import '../../../src/styles/upgrade.css'
import { Button } from "@mui/material";
import { db } from './firebase/firebase';
import {useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { doc, setDoc, getDocs, collection,getDoc ,query, addDoc, where, updateDoc } from "firebase/firestore";
import { de_encrypt } from "../../encryption";
import BaseNav from "./sub-components/BaseNav";
const Upgrade = () => {
     const navigate = useNavigate();
     const [pac,setPac]=useState(null);
    const user_key = de_encrypt(localStorage.getItem('user-key'));
    const [code, setCode] = useState(null);
     const [error,setError]=useState('');
     const [clicked,setClicked]=useState(false);
     const allCodes=[];
    const all_user_coupon_code=[];
    const ref = collection(db, "coupon");
    const userRef=collection(db,"user");
    const assignPackageProps = (package_type) => {
        var amount = '';
        var mine_amount = '';
        var mine_duration = '';
        var referral_bonus='';
        switch (package_type) {
            case "starter":
                amount = 250;
                mine_amount = 10;
                mine_duration = 1;
                referral_bonus=600;
                break;

            case "premium":
                amount = 500;
                mine_amount = 40;
                mine_duration = 1;
                referral_bonus=1250;
                break;

            case "premium pro":
                amount = 750;
                mine_amount = 100;
                mine_duration = 1;
                referral_bonus=2500
                break;

            case "elite":
                amount = 1000;
                mine_amount = 150;
                mine_duration = 1;
                referral_bonus=5000
                break;

            case "expert":
                amount = 1250;
                mine_amount = 4800;
                mine_duration = 24;
                referral_bonus=7500
                break;

            case "worker":
                amount = 1500;
                mine_amount = 6000;
                mine_duration = 24;
                referral_bonus=12500
                break;
        }
        return { amount, mine_amount, mine_duration,referral_bonus }
    }
     const upgrade = async ()=>{
         setClicked(true);
          setError('');
         const q=query(ref)
         const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const code={info:doc.data()}
            allCodes.push(code)
        });
        const q2=query(userRef)
        const userSnapShot= await getDocs(q2)
        userSnapShot.forEach((doc)=>{
            const user={user:doc.data()}
            all_user_coupon_code.push(user);
        })
     
         if(pac != 'worker'){
             if(allCodes.map((code)=>(code.info.code)).includes(code)){
        //    if coupon code is not taken by any user
                   if(all_user_coupon_code.map((user)=>(user.user.coupon)).includes(code)){
                     setClicked(false);
                     setError('This Coupon Code has been used!!!');
                   }else{
                       const coupon_type=allCodes.filter((cod)=>{ return code===cod.info.code})[0].info.package_type;
                       const userRef = doc(db, "user", user_key);
                       const data = {
                        coupon:code,
                        package_type:coupon_type,
                        mine_earning: assignPackageProps(coupon_type).mine_amount,
                        mine_duration: assignPackageProps(coupon_type).mine_duration,
                        referral_bonus:assignPackageProps(coupon_type).referral_bonus
                       }   
                        const notification_data = {
                        type: "upgrade",
                        subject: "Package upgrade",
                        body: `Congratulations, you have just upgraded your package to ${coupon_type} `,
                        time: Date.now(),
                        to: user_key
                    }
                    const docRef = await addDoc(collection(db, "notifications"), notification_data)
                         await updateDoc(userRef, data);
                         navigate('/dashboard');
                   }
             }else{
               setClicked(false)
               setError('Invalid Coupon Code!!!')
             }     
         }else{
           setError('You are presently on the highest package');    
         }     

      
     
     
     }
     useEffect(
        ()=>{
      
            
              if(pac==null){
                  ( async ()=>{
                      const docRef = doc(db, "user", user_key);
                      const docSnap = await getDoc(docRef);
                      
                       setPac(docSnap.data().package_type)

                  })();
                }
        return ()=>{
         setPac('unmounted')
        }
 

        },[pac])
    return ( 
        <div className="dashboard upgrade-container utility">
           <Header />
           <BaseNav active={"Upgrade"} />
            {/* <div className="upgrade-box"> */}
            {pac &&    <div className="gc-box">
                    <span>To upgrade your package, Enter promotion code </span>
                    <div className="text-field">
                    <input type="text" placeholder='Enter promotion code' value={code} onChange={(e)=>{setCode(e.target.value)}} />
                    </div>
                    { !clicked &&  <div className="btn">
                        <Button variant="contained" style={{backgroundColor:"#9900EF"}} onClick={upgrade}> Proceed</Button>   
                    </div>}
                   
                  {clicked && <div className="btn">
                        <Button variant="contained" style={{backgroundColor:"#9900EF"}} > Processing</Button>   
                    </div> }
                  <p style={{color:"red",transform:"translateY(2em)",fontSize:"13px"}}>{error}</p>
                </div>}
                <div className="buy-coupon">
                <span>I don't have a promotion code?</span>
                <a href="https://viralclicks-mine.net/buy-coupon-code">Click here</a>
                </div>
            {/* </div> */}
            
        </div> 
     );
}
 
export default Upgrade;
